import { render, staticRenderFns } from "./CouponDialog.vue?vue&type=template&id=a0dc567c&scoped=true"
import script from "./CouponDialog.vue?vue&type=script&lang=js"
export * from "./CouponDialog.vue?vue&type=script&lang=js"
import style0 from "./CouponDialog.vue?vue&type=style&index=0&id=a0dc567c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dc567c",
  null
  
)

export default component.exports